import { ReportFeatures } from '@hcs/types';

export const SIMILAR_PROPERTIES_CHARTS_FEATURES = [
  ReportFeatures.SimilarPropertiesChart,
  ReportFeatures.CompsSimilarPropertiesCharts,
];
